<style>
	.collapse-a:before {
		font-family: "Font Awesome 5 Free";
		content: "\f067";
		margin-left: 10px
	}

	.collapse-a .collapse-a-title:before {
		content: "جزئیات بیشتر";
	}

	.collapse-a.lessDetails:before {
		font-family: "Font Awesome 5 Free";
		content: "\f068";
		margin-left: 10px
	}

	.collapse-a.lessDetails .collapse-a-title:before {
		content: "جزئیات کمتر";
	}

	.v-select ul li {
		padding: 10px 5px !important
	}
</style>
<template>
	<div id="page">
		<div class="page-content">
			<div class="page-title page-title-small">
				<h2>
					<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>ثبت فعالیت های روزانه
					<button data-menu="HelpMenu" class="position-static mr-2"><i class="fa fa-question-circle helpIco"></i></button>
				</h2>
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
			</div>
			<div class="card header-card shape-rounded" data-card-height="150">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
				<div class="card-bg bg-20"></div>
			</div>
			<div class="card card-style bg-theme pb-0">
				<div class="content">
					<ul class="nav nav-pills justify-content-center" id="pills-tab" role="tablist">
						<li class="nav-item flex-1" role="presentation" @click="onTabClick('pills-details');">
							<button class="nav-link text-center rounded-s active w-100" :class="{'active':activeTabTitle=='#pills-details'}" id="pills-details-tab" data-toggle="pill" data-target="#pills-details" role="tab" aria-controls="pills-details" aria-selected="true" style="border: 1px solid #007bff">عمومی</button>
						</li>

						<li class="nav-item flex-1" role="presentation" @click="onTabClick('pills-presenceInfo');">
							<button class="nav-link text-center rounded-s w-100" :class="{'active':activeTabTitle=='#pills-presenceInfo'}" id="pills-presenceInfo-tab" data-toggle="pill" data-target="#pills-presenceInfo" role="tab" aria-controls="pills-presenceInfo" aria-selected="false" style="border: 1px solid #007bff">جزئیات حضوروغیاب</button>
						</li>
					</ul>
					<div class="tab-content mt-4" id="pills-tabContent">
						<div class="tab-pane fade active show" id="pills-details" :class="{'active show':activeTabTitle=='#pills-details'}" role="tabpanel" aria-labelledby="pills-details-tab">

							<!--جزئیات-->
							<!--<div class="input-style input-style-2 has-icon input-required">
								<div class="d-flex">
									<div class="w-100">
										<i class="input-icon fa fa-hashtag color-magenta2-light"></i>
										<span class="color-highlight" :class="{'input-style-1-active' : otherWorkModel.workNo!==null}">شماره فعالیت</span>
										<input class="form-control ltr d-inline-block" type="text" readonly v-model="otherWorkModel.workNo" @input="v$.otherWorkModel.workNo.$touch()" :class="{invalid:v$.otherWorkModel.workNo.$error}">
									</div>
									<button class="btn btn-xxs rounded-sm btn-primary btnNexInput" @click="getOtherWorkNo"><i class="fa fa-redo"></i></button>
								</div>
								<p class="text-danger" v-if="v$.otherWorkModel.workNo.required.$invalid && v$.otherWorkModel.workNo.$dirty">شماره فعالیت وارد نشده است</p>
							</div>-->

							<div>
								<div class="input-style input-style-2 has-icon input-required">
									<i class="input-icon fa fa-calendar-times color-magenta2-light"></i>
									<span class="color-highlight" :class="{'input-style-1-active' : otherWorkModel.workDate!==null}">تاریخ فعالیت</span>
									<input type="text" class="form-control ltr d-inline-block" v-model="otherWorkModel.workDate" id="endDT" :class="{invalid:v$.otherWorkModel.workDate.$error}" />
								</div>
								<p class="text-danger" v-if="v$.otherWorkModel.workDate.required.$invalid && v$.otherWorkModel.workDate.$dirty">لطفا تاریخ فعالیت را وارد کنید.</p>

							</div>
							<div class="input-style input-style-2 has-icon input-required">
								<i class="input-icon fa fa-check color-magenta2-light"></i>
								<span class="color-highlight" :class="{'input-style-1-active' : otherWorkModel.subject!==null}">عنوان</span>
								<input id="Subject" class="form-control" type="text" v-model="otherWorkModel.subject" @input="v$.otherWorkModel.subject.$touch()" :class="{invalid:v$.otherWorkModel.subject.$error}">
								<p class="text-danger" v-if="v$.otherWorkModel.subject.required.$invalid && v$.otherWorkModel.subject.$dirty">لطفا عنوان را وارد کنید.</p>
							</div>
							<div class="mb-3">
								<v-select dir="rtl" label="title" placeholder="کارگروه" :filterable="WorkGroupList.length>10" :searchable="WorkGroupList.length>10" :options="WorkGroupList" :reduce="p => p.workGroupId" v-model="otherWorkModel.workGroupId" @option:selected="onChangeWorkGroup">
									<template slot="option">
										<div class="d-center">
											{{ option.title }}
										</div>
									</template>
								</v-select>
							</div>

							<div class="mb-3">
								<v-select :class="{invalid:v$.otherWorkModel.otherWorkTypeId.$error}" dir="rtl" label="title" placeholder="نوع فعالیت" :filterable="otherWorkTypeList.length>10" :searchable="otherWorkTypeList.length>10" :options="otherWorkTypeList" @search="onSearchOtherWorkType" :reduce="p => p.otherWorkTypeId" @option:selected="onChangeType" v-model="otherWorkModel.otherWorkTypeId">
									<template #list-footer>
										<button v-if="isMinVersion" @click="onShowTypeModal(true)" class="btn btn-xxs rounded-xl btn-success list-add-btn"><i class="fa fa-plus"></i></button>
									</template>
								</v-select>
								<p class="text-danger" v-if="v$.otherWorkModel.otherWorkTypeId.required.$invalid && v$.otherWorkModel.otherWorkTypeId.$dirty">لطفا نوع فعالیت را انتخاب کنید.</p>
							</div>

							<div class="mb-4">
								<div class="d-flex justify-content-between align-items-center">
									<div class="d-flex align-items-center">
										<i class="fa fa-clock pl-2 color-magenta2-light"></i>
										<label class="mb-0 font-12 font-weight-bold">زمان استفاده شده</label>
									</div>
									<div class="d-flex flex-column">
										<div class="d-flex justify-content-between align-items-center">
											<label class="mb-0 font-12 font-weight-bold w-50 text-center">دقیقه</label>
											<span class="font-13 font-weight-bold px-3"></span>
											<label class="mb-0 font-12 font-weight-bold w-50 text-center">ساعت</label>
										</div>
										<div class="ltr">
											<input placeholder="00" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="tel" v-model="otherWorkModel.workUsedTimeHour" @input="v$.otherWorkModel.workUsedTimeHour.$touch()" :class="{invalid:v$.otherWorkModel.workUsedTimeHour.$error}">
											<span class="font-13 font-weight-bold px-2">:</span>
											<input placeholder="00" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="tel" v-model="otherWorkModel.workUsedTimeMinute" @input="() => { if(otherWorkModel.workUsedTimeMinute  > 59 || otherWorkModel.workUsedTimeMinute < 0) { otherWorkModel.workUsedTimeMinute = ''}}" maxlength="2" :class="{invalid:v$.otherWorkModel.workUsedTimeMinute.$error}">
										</div>
									</div>
								</div>
								<p class="text-danger mt-2" v-if="v$.otherWorkModel.workUsedTimeHour.between.$invalid && v$.otherWorkModel.workUsedTimeHour.$dirty">ساعت باید مقداری از ۰ تا ۱۰۰۰ داشته باشد.</p>
								<p class="text-danger mt-2" v-if="v$.otherWorkModel.workUsedTimeMinute.between.$invalid && v$.otherWorkModel.workUsedTimeMinute.$dirty">دقیقه باید مقداری از ۰ تا ۵۹ داشته باشد.</p>

							</div>



							<div class="collapse pt-3" id="collapse-moreDetails">
								<div class="input-style input-style-2 has-icon input-required">
									<i class="input-icon fa fa-check color-magenta2-light"></i>
									<span class="color-highlight" :class="{'input-style-1-active' : otherWorkModel.quantity!==null}">فراوانی</span>
									<input id="Quantity" class="form-control" type="tel" v-model="otherWorkModel.quantity" pattern="\d*">
								</div>






								<div class="mb-3" v-if="!isMinVersion">
									<div class="d-flex">
										<div class="w-100">
											<v-select dir="rtl" v-model="otherWorkModel.personId" label="title" @option:selected="onchangePerson" placeholder="شخص/شرکت" :filter="PersonFilter" :options="PersonList" :reduce="p => p.personId">
												<template v-slot="option">
													<div class="d-center">
														{{ option.title }}
													</div>
												</template>
											</v-select>
										</div>
									</div>
								</div>
								<div class="mb-3">
									<div class="d-flex">
										<div class="w-100">
											<v-select dir="rtl" v-model="otherWorkModel.projectId" label="fullTitle" @option:selected="onchangeProject" placeholder="پروژه" :filter="ProjectFilter" :options="ProjectList" :reduce="p => p.projectId">
												<template v-slot="option">
													<div class="d-center">
														{{ option.fullTitle }}
													</div>
												</template>
											</v-select>
										</div>
									</div>
								</div>


								<div class="mb-3" v-if="(!isMinVersion) && HasCom">
									<div class="d-flex">
										<div class="w-100">
											<v-select dir="rtl" v-model="otherWorkModel.preInvoiceId" label="strDocNo" @option:selected="onchangePreInvoice" placeholder=" پیش فاکتور فروش کالا/خدمات" :filter="PreInvoiceFilter" :options="PreInvoiceList" :reduce="p => p.preInvoiceId">
												<template v-slot="option">
													<div class="d-center">
														<span>{{  option.strDocNo }}</span>
													</div>
												</template>
											</v-select>
										</div>
									</div>
								</div>
								<div class="mb-3" v-if="!isMinVersion">
									<div class="d-flex">
										<div class="w-100">
											<v-select dir="rtl" v-model="otherWorkModel.contractId" label="strDocNo" @option:selected="onchangeContract" placeholder="قرارداد" :filter="ContractFilter" :options="ContractList" :reduce="p => p.contractId">
												<template v-slot="option">
													<div class="d-center">
														<span>{{  option.strDocNo }}</span>
													</div>
												</template>
											</v-select>
										</div>
									</div>
								</div>

								<div class="mb-3" v-if="(!isMinVersion) && HasCom">
									<div class="d-flex">
										<div class="w-100">
											<v-select dir="rtl" v-model="otherWorkModel.invoiceId" label="strDocNo" @option:selected="onchangeInvoice" placeholder="فاکتور فروش کالا/خدمات" :filter="InvoiceFilter" :options="InvoiceList" :reduce="p => p.invoiceId">
												<template v-slot="option">
													<div class="d-center">
														<span>{{  option.strDocNo }}</span>
													</div>
												</template>
											</v-select>
										</div>
									</div>
								</div>
								<div class="mb-3" v-if="!isMinVersion">
									<div class="d-flex">
										<div class="w-100">
											<v-select dir="rtl" v-model="otherWorkModel.letterId" label="strDocNo" @option:selected="onchangeLetter" placeholder="نامه" :filter="LetterFilter" :options="LetterList" :reduce="p => p.letterId">
												<template v-slot="option">
													<div class="d-center">
														<span>{{  option.strDocNo }}</span>
													</div>
												</template>
											</v-select>
										</div>
									</div>
								</div>

								<div class="mb-3" v-if="!isMinVersion">
									<div class="d-flex">
										<div class="w-100">
											<v-select dir="rtl" v-model="otherWorkModel.meetingId" label="strDocNo" @option:selected="onchangeMeeting" placeholder="جلسه" :filter="MeetingFilter" :options="MeetingList" :reduce="p => p.meetingId">
												<template v-slot="option">
													<div class="d-center">
														<span>{{  option.strDocNo }}</span>
													</div>
												</template>
											</v-select>
										</div>
									</div>
								</div>

								<div class="mb-3" v-if="(!isMinVersion) && HasCom">
									<div class="d-flex">
										<div class="w-100">
											<v-select dir="rtl" v-model="otherWorkModel.buyId" label="strDocNo" @option:selected="onchangeBuy" placeholder="خرید کالا/خدمات" :filter="BuyFilter" :options="BuyList" :reduce="p => p.buyId">
												<template v-slot="option">
													<div class="d-center">
														<span>{{  option.strDocNo }}</span>
													</div>
												</template>
											</v-select>
										</div>
									</div>
								</div>
								<div class="mb-3">
									<v-select dir="rtl" label="title" placeholder="منشن" multiple chips :options="LocalUserListForMention" :reduce="p => p.userId" v-model="otherWorkModel.mentionUserIdsList">
										<template slot="option">
											<div class="d-center">
												{{ option.title }}
											</div>
										</template>
									</v-select>
								</div>


								<div class="card mx-0 mb-2">
									<div class="list-group list-custom-small list-icon-0 bg-blue1-dark px-2 collapse-description-box">
										<button data-toggle="collapse" data-target="#collapse-description">
											<i class="fa fa-edit mt-2"></i>
											<span>توضیحات</span>
											<i class="fa fa-angle-down"></i>
										</button>
									</div>
									<div class="collapse collapse-reminderCalendars show" id="collapse-description">
										<textarea v-model="otherWorkModel.description" class="form-control line-height-m text-justify rounded-sm" rows="3" style="height:200px"></textarea>
									</div>
								</div>
								<button class="btn btn-link speechToTextBtn mb-2" @pointerdown="startR"
										@pointerup="stopR">
									<span :class="btnRecord">
										<span class="speechToTextBtn-text" v-if="showType">شروع به صحبت کنید...</span>
									</span>
									<img class="ml-3" v-if="showType" src="/assets/images/wave.gif" width="38" height="38" />
								</button>
								<!--<div class="input-style input-style-2 has-icon input-required mb-3">
									<i class="input-icon fa fa-pen color-magenta2-light"></i>
									<span class="color-highlight">توضیحات</span>
									<textarea v-model="otherWorkModel.description" class="form-control line-height-m text-justify" rows="3" style="height:200px" @input="v$.otherWorkModel.description.$touch()" :class="{invalid:v$.otherWorkModel.description.$error}"></textarea>
									<p class="text-danger" v-if="v$.otherWorkModel.description.required.$invalid && v$.otherWorkModel.description.$dirty">لطفا توضیحات را وارد کنید.</p>
								</div>-->

								<att-list v-bind:destination="'OtherWork'" @setAttList="SetAttList($event)" @attInProgress="AttInProgress($event)" :canAdd="true" :canDelete="true" :oldAttList="[]" :hasLocation="true"></att-list>

							</div>

							<button data-toggle="collapse" data-target="#collapse-moreDetails" class="btn btn-xxs btn-full rounded-sm bg-highlight font-900 collapse-a w-100" id="moreLessDetails" @click="toggleClasslessDetails()">
								<span class="collapse-a-title"></span>
							</button>

							<button type="button" :disabled="Loading || attInProgress" class="btn btn-xxs mt-2 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="CreateOtherWork">
								<i class="fa fa-check font-10 ml-2"></i>
								ثبت
							</button>
						</div>

						<div class="tab-pane fade" id="pills-presenceInfo" :class="{'active show':activeTabTitle=='#pills-presenceInfo'}" role="tabpanel" aria-labelledby="pills-presenceInfo-tab">
							<!--مستندات حضور و غیاب-->
							<div class="mb-3">
								<div class="d-flex mb-3">
									<div class="w-100">
										<v-select dir="rtl" v-model="otherWorkModel.arrivalUserPresenceId" @option:selected="onchangeUserPresenceArrival(false)" @option:cleared="onClearedUserPresenceArrival" label="fullTitle" :filter="UserPresenceArrivalFilter" placeholder="زمان ورود" :options="UserPresenceArrivalListForRef" :reduce="p => p.userPresenceId">
											<template v-slot="option">
												<div class="d-center">
													<span>{{  option.fullTitle }}</span>
												</div>
											</template>
										</v-select>
									</div>
									<button class="btn btn-xxs rounded-sm btn-primary btnNexInput" @click="ShowCreateLocationModal">
										<i class="fa fa-plus"></i>
									</button>
									<button class="btn btn-xxs rounded-sm btn-success btnNexInput" @click="onchangeUserPresenceArrival(true)">
										<i class="fa fa-sync"></i>
									</button>
								</div>
								<div v-if="ShowArrivalUserPresenceInfo">
									<div class="mb-4">
										<l-map style="height:300px" :zoom="16" :center="mapLocationObjectArrival" v-if="mapLocationObjectArrival!=null">
											<l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
											<l-marker :lat-lng="mapLocationObjectArrival"></l-marker>
										</l-map>
									</div>
									<div class="input-style input-style-2 mt-2">
										<span class="mt-2 color-highlight input-style-1-active">نشانی موقعیت ورود</span>
										<textarea readonly v-model="arrivalUserPresenceAddress" placeholder="آدرس ورود" class="form-control line-height-m text-justify rounded-sm" rows="3" style="height:100px"></textarea>
									</div>
									<button type="button" class="btn btn-xxs mt-3 mb-3 btn-full bg-green2-dark rounded-sm font-900 w-100" @click="showMapLocation(false)"><i class="fa fa-map-marked font-10 ml-2"></i>نمایش موقعیت روی نقشه</button>
								</div>
							</div>


							<div class="mb-3">
								<div class="d-flex mb-3">
									<div class="w-100">
										<v-select dir="rtl" v-model="otherWorkModel.departureUserPresenceId" @option:selected="onchangeUserPresenceDeparture(false)" label="fullTitle" :filter="UserPresenceDepartureFilter" placeholder="زمان خروج" :options="UserPresenceDepartureListForRef" :reduce="p => p.userPresenceId">
											<template v-slot="option">
												<div class="d-center">
													<span>{{  option.fullTitle }}</span>
												</div>
											</template>
										</v-select>
									</div>
									<button class="btn btn-xxs rounded-sm btn-primary btnNexInput" @click="ShowCreateLocationModal">
										<i class="fa fa-plus"></i>
									</button>
									<button class="btn btn-xxs rounded-sm btn-success btnNexInput" @click="onchangeUserPresenceDeparture(true)">
										<i class="fa fa-sync"></i>
									</button>
								</div>
								<div v-if="ShowDepartureUserPresenceInfo">
									<div class="mb-4">
										<l-map style="height:300px" :zoom="16" :center="mapLocationObjectDeparture" v-if="mapLocationObjectDeparture!=null">
											<l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
											<l-marker :lat-lng="mapLocationObjectDeparture"></l-marker>
										</l-map>
									</div>
									<div class="input-style input-style-2 mt-2">
										<span class="mt-2 color-highlight input-style-1-active">نشانی موقعیت خروج</span>
										<textarea readonly v-model="departureUserPresenceAddress" placeholder="آدرس خروج" class="form-control line-height-m text-justify rounded-sm" rows="3" style="height:100px"></textarea>
									</div>
									<div>
										<button type="button" class="btn btn-xxs mt-3 mb-3 btn-full bg-green2-dark rounded-sm font-900 w-100" @click="showMapLocation(true)"><i class="fa fa-map-marked font-10 ml-2"></i>نمایش موقعیت روی نقشه</button>
									</div>
								</div>
							</div>

						</div>

					</div>


				</div>






			</div>
		</div>

		<create-Location-Modal v-if="openCreateLocationModal" :defaultLocation="null" :defaultAddress="null" @close="CloseCreateLocationModal"></create-Location-Modal>


		<date-picker type="date" v-model="otherWorkModel.workDate" format="jYYYY/jMM/jDD" element="endDT" />

		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>درحال ارسال اطلاعات ...</div>
			</div>
		</transition>
		<Help-Menu title="راهنمای ثبت فعالیت" keyEn="TaskList"></Help-Menu>
		<!--<div id="createOtherWorkHelp" class="menu menu-box-right bg-gray" data-menu-width="100%" data-menu-effect="menu-over">
			<div class="position-relative">
				<button @click="pauseAllVid()" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
				<div class="card" data-card-height="90">
					<div class="card-top">
						<div class="page-title page-title-small">
							<h2 class="text-center">راهنمای ثبت فعالیت</h2>
						</div>
					</div>
					<div class="card-overlay bg-highlight opacity-95"></div>
					<div class="card-overlay dark-mode-tint"></div>
					<div class="card-bg bg-20"></div>
				</div>
				<div class="card card-style">
					<div class="content mt-0 pb-2">
						<div class="list-group list-custom-small list-icon-0 mt-3 border-b">
							<div data-toggle="collapse" href="#collapse-0" class="collapsed list-group-div" aria-expanded="false">
								<i class="fa font-14 fa-info-circle color-magenta1-light"></i>
								<span class="font-14">معرفی موبایل اپلیکیشن تسکینو  <span class="badge bg-red2-light mt-0 px-2 py-2 mr-2 position-static">مهم</span></span>

								<i class="fa fa-angle-down line-height-xl"></i>
							</div>
						</div>
						<div class="collapse border-b pb-3" id="collapse-0" style="">
							<div class="d-flex justify-content-center">
								<video class="responsive-video" controls id="video0" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
									<source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-OtherWork.mp4" type="video/mp4">
								</video>
							</div>
							<a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-OtherWork.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
						</div>
						<div class="list-group list-custom-small list-icon-0 mt-3 border-b">
							<div data-toggle="collapse" href="#collapse-1" class="collapsed list-group-div" aria-expanded="false">
								<i class="far font-14 fa-check-circle color-red2-dark"></i>
								<span class="font-14">راهنمای ثبت فعالیت</span>
								<i class="fa fa-angle-down line-height-xl"></i>
							</div>
						</div>
						<div class="collapse border-b pb-3" id="collapse-1" style="">
							<div class="d-flex justify-content-center">
								<video class="responsive-video" controls id="video1" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
									<source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/add-otherWork.mp4" type="video/mp4">
								</video>
							</div>
							<a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/add-otherWork.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
						</div>
					</div>
				</div>
			</div>
		</div>-->
		<transition name="modal" enter-active-class="animated fadeIn" appear>
			<div v-if="showTypeModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container">
						<div class="modal-body m-0">
							<slot name="body">
								<otherwork-type-create :inModal="true" @close="showTypeModal=false"></otherwork-type-create>
							</slot>
						</div>
						<div class="modal-footer py-1 px-2">
							<slot name="footer">
								<button class="btn btn-xxs rounded-s bg-red1-light" @click="showTypeModal=false">
									<i class="fa fa-times ml-2"></i>
									بستن
								</button>
							</slot>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>
<script>
	import useVuelidate from '@vuelidate/core'
	import {
		required, between
	} from "@vuelidate/validators";
	import 'vue-select/dist/vue-select.css';
	import { maska } from 'maska'
	import AttList from '../Components/AttList.vue';
	import otherWorkTypeCreate from '../OtherWorkType/CreateOtherWorkType.vue';
	import HelpMenu from '../Components/HelpMenu.vue';
	import CreateLocationModal from '../Components/CreateLocationModal.vue';
	import DatePicker from 'vue3-persian-datetime-picker';
	import VueSimpleAlert from 'vue3-simple-alert';


	import { LMap, LMarker, LTileLayer } from "@vue-leaflet/vue-leaflet";
	import "leaflet/dist/leaflet.css"
	import { latLng } from "leaflet";


	import { Icon } from 'leaflet';

	delete Icon.Default.prototype._getIconUrl;
	Icon.Default.mergeOptions({
		iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
		iconUrl: require('leaflet/dist/images/marker-icon.png'),
		shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
	});

	const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition
	export default {
		components: {
			"Help-Menu": HelpMenu,
			DatePicker,
			"att-list": AttList,
			"create-Location-Modal": CreateLocationModal,
			"otherwork-type-create": otherWorkTypeCreate,
			"l-map": LMap,
			"l-tile-layer": LTileLayer,
			"l-marker": LMarker
		},
		setup: () => ({ v$: useVuelidate() }),
		data() {
			return {
				attInProgress: false,
				modified: false,
				showTypeModal: false,
				otherWorkSearchText: null,
				showType: false,
				openCreateLocationModal: false,

				ShowArrivalUserPresenceInfo: false,
				arrivalUserPresenceAddress: "",
				mapLocationArrival: "",
				mapLocationObjectArrival: null,


				ShowDepartureUserPresenceInfo: false,
				departureUserPresenceAddress: "",
				mapLocationDeparture: "",
				mapLocationObjectDeparture: null,


				url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
				attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
				sr: null,
				btnRecord: "btn btn-danger speechToTextBtn-i",
				otherWorkModel: {
					workNo: null,
					workDate: null,
					otherWorkId: 0,
					otherWorkTypeId: null,
					taskFolderId: this.$route.params.taskFolderId,

					workUsedTime: null,
					subject: null,
					userId: 0,
					quantity: 0,
					description: " ",
					workUsedTimeMinute: null,
					workUsedTimeHour: null,
					attList: [],


					departureUserPresenceId: null,
					arrivalUserPresenceId: null,
					mentionUserIdsList: [],
					workGroupId: null,//
					personId: null,//
					projectId: null,//
					invoiceId: null,//
					preInvoiceId: null,//
					contractId: null,//
					letterId: null,//
					meetingId: null,//
					preBuyInvoiceId: null,
					buyId: null,//
					projectTitle: null,
					preInvoiceTitle: null,
					invoiceTitle: null,
					letterTitle: null,
					buyTitle: null,
					contractTitle: null,
					personTitle: null,
					meetingTitle: null,
					preBuyInvoiceTitle: null,
					leadTitle: null,

				},

			};
		},
		computed: {
			Loading() {
				return this.$store.getters.GetLoading;
			},
			otherWorkTypeList() {
				return this.$store.getters.GetOtherWorkTypeList;
			},
			propsToWatch() {
				return `${this.otherWorkModel.subject}|${this.otherWorkModel.description}|${this.otherWorkModel.otherWorkTypeId}|${this.otherWorkModel.projectId}|${this.otherWorkModel.attList}|${this.otherWorkModel.workUsedTime}`;
			},



			PersonList() {
				return this.$store.getters.GetPersonList;
			},
			ProjectList() {
				return this.$store.getters.GetProjectList;
			},
			PreInvoiceList() {
				return this.$store.getters.GetPreInvoiceList;
			},
			ContractList() {
				return this.$store.getters.GetContractList;
			},
			InvoiceList() {
				return this.$store.getters.GetInvoiceList;
			},
			LetterList() {
				return this.$store.getters.GetLetterList;
			},
			MeetingList() {
				return this.$store.getters.GetMeetingList;
			},
			PreBuyInvoiceList() {
				return this.$store.getters.GetPreBuyInvoiceList;
			},
			BuyList() {
				return this.$store.getters.GetBuyList;
			},
			LocalUserListForMention() {
				return this.$store.getters.GetLocalUserListForMention;
			},
			WorkGroupList() {
				return this.$store.getters.GetWorkGroupList;
			},
			HasCom() {
				return this.$store.getters.GetHasCom;
			},
			UserPresenceDepartureListForRef() {
				return this.$store.getters.GetDepartureListForRef;
			},
			UserPresenceArrivalListForRef() {
				return this.$store.getters.GetArrivalListForRef;
			},
		},
		watch: {
			propsToWatch: {
				handler: function () {
					console.log(this.modified);
					this.modified = true;
				},
				deep: true
			},
			'otherWorkModel.workGroupId'(value) {
				this.onChangeWorkGroup();
			},
			'otherWorkModel.personId'(value) {
				this.onchangePerson();
			},
			'otherWorkModel.projectId'(value) {
				this.onchangeProject();
			},
			'otherWorkModel.preInvoiceId'(value) {
				this.onchangePreInvoice();
			},
			'otherWorkModel.contractId'(value) {
				this.onchangeContract();
			},
			'otherWorkModel.meetingId'(value) {
				this.onchangeMeeting();
			},
			'otherWorkModel.invoiceId'(value) {
				this.onchangeInvoice();
			},
			'otherWorkModel.letterId'(value) {
				this.onchangeLetter();
			},
			'otherWorkModel.buyId'(value) {
				this.onchangeBuy();
			}
		},
		created() {
			this.getServerDateTime();
			this.$store.dispatch("GetOtherWorkTypeListFromServer");

			this.$store.dispatch("GetPersonListFromServer", {});
			this.$store.dispatch("GetProjectListFromServer", {});
			this.$store.dispatch("GetLocalUserListForMention", {});
			this.$store.dispatch("GetPreInvoiceAbstractForPerson", {});
			this.$store.dispatch("GetContractAbstractForPerson", {});
			this.$store.dispatch("GetInvoiceAbstractForPerson", {});
			this.$store.dispatch("GetLetterAbstractForPerson", {});
			this.$store.dispatch("GetMeetingAbstractForPerson", {});
			this.$store.dispatch("GetBuyAbstractForPerson", {});
			this.$store.dispatch("GetWorkGroupListFromServer", {});



			this.getOtherWorkNo();
		},


		methods: {
			ShowCreateLocationModal() {
				this.openCreateLocationModal = true;
			},
			CloseCreateLocationModal() {
				this.openCreateLocationModal = false;
			},



			PersonFilter(item, queryText, itemText) {
				if (queryText.length > 3)
					this.$store.dispatch("GetPersonListFromServer", {
						text: queryText,
					});
				return this.$store.getters.GetPersonList;
			},
			onchangePerson() {
				this.otherWorkModel.projectId = null;
				this.otherWorkModel.invoiceId = null;
				this.otherWorkModel.preInvoiceId = null;
				this.otherWorkModel.contractId = null;
				this.otherWorkModel.letterId = null;
				this.otherWorkModel.meetingId = null;
				this.otherWorkModel.preBuyInvoiceId = null;
				this.otherWorkModel.buyId = null;
				this.$store.dispatch("GetProjectListFromServer", {
					personId: this.otherWorkModel.personId,
				});
				this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
					personId: this.otherWorkModel.personId,
				});
				this.$store.dispatch("GetContractAbstractForPerson", {
					personId: this.otherWorkModel.personId,
				});
				this.$store.dispatch("GetInvoiceAbstractForPerson", {
					personId: this.otherWorkModel.personId,
				});
				this.$store.dispatch("GetLetterAbstractForPerson", {
					personId: this.otherWorkModel.personId,
				});
				this.$store.dispatch("GetMeetingAbstractForPerson", {
					personId: this.otherWorkModel.personId,
				});
				this.$store.dispatch("GetBuyAbstractForPerson", {
					personId: this.otherWorkModel.personId,
				});
			},


			ProjectFilter(item, queryText, itemText) {
				if (queryText.length > 3)
					this.$store.dispatch("GetProjectListFromServer", {
						text: queryText,
						personId: this.otherWorkModel.personId,
					});
				return this.$store.getters.GetProjectList;
			},
			onchangeProject() {
				this.otherWorkModel.contractId = null;
				this.otherWorkModel.meetingId = null;
				this.$store.dispatch("GetContractAbstractForPerson", {
					text: "",
					personId: this.otherWorkModel.personId,
					projectId: this.otherWorkModel.projectId,
				});
				this.$store.dispatch("GetMeetingAbstractForPerson", {
					personId: this.otherWorkModel.personId,
					projectId: this.otherWorkModel.projectId,
				});
			},


			PreInvoiceFilter(item, queryText, itemText) {
				if (queryText.length > 0)
					this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
						text: queryText,
						personId: this.otherWorkModel.personId,
						projectId: this.otherWorkModel.projectId,
					});
				return this.$store.getters.GetPreInvoiceList;
			},
			onchangePreInvoice() {
				//this.otherWorkModel.contractId = null;
				this.otherWorkModel.invoiceId = null;
				this.$store.dispatch("GetInvoiceAbstractForPerson", {
					text: "",
					preInvoiceId: this.otherWorkModel.preInvoiceId,
					contractId: this.otherWorkModel.contractId,
					personId: this.otherWorkModel.personId,
				});
			},



			ContractFilter(item, queryText, itemText) {
				if (queryText.length > 3)
					this.$store.dispatch("GetContractAbstractForPerson", {
						text: queryText,
						personId: this.otherWorkModel.personId,
					});
				return this.$store.getters.GetContractList;
			},
			onchangeContract() {
				this.otherWorkModel.invoiceId = null;
				this.otherWorkModel.buyId = null;
				this.otherWorkModel.meetingId = null;
				this.$store.dispatch("GetInvoiceAbstractForPerson", {
					text: "",
					preInvoiceId: this.otherWorkModel.preInvoiceId,
					contractId: this.otherWorkModel.contractId,
					personId: this.otherWorkModel.personId,
				});
				this.$store.dispatch("GetMeetingAbstractForPerson", {
					personId: this.otherWorkModel.personId,
					projectId: this.otherWorkModel.projectId,
					contractId: this.otherWorkModel.contractId,
				});
				this.$store.dispatch("GetBuyAbstractForPerson", {
					personId: this.otherWorkModel.personId,
					prebuyInvoiceId: this.otherWorkModel.prebuyInvoiceId,
					contractId: this.otherWorkModel.contractId,
				});

			},



			InvoiceFilter(item, queryText, itemText) {
				if (queryText.length > 0)
					this.$store.dispatch("GetInvoiceAbstractForPerson", {
						text: queryText,
						preInvoiceId: this.otherWorkModel.preInvoiceId,
						contractId: this.otherWorkModel.contractId,
						personId: this.otherWorkModel.personId,
					});
				return this.$store.getters.GetInvoiceList;
			},
			onchangeInvoice() {
				console.log("")
			},



			LetterFilter(item, queryText, itemText) {
				if (queryText.length > 0)
					this.$store.dispatch("GetLetterAbstractForPerson", {
						text: queryText,
						personId: this.otherWorkModel.personId,
					});
				return this.$store.getters.GetLetterList;
			},
			onchangeLetter() {
				console.log("")
			},



			MeetingFilter(item, queryText, itemText) {
				if (queryText.length > 0)
					this.$store.dispatch("GetMeetingAbstractForPerson", {
						text: queryText,
						personId: this.otherWorkModel.personId,
						contractId: this.otherWorkModel.contractId,
						projectId: this.otherWorkModel.projectId,
					});
				return this.$store.getters.GetMeetingList;
			},
			onchangeMeeting() {
				console.log("")
			},

			BuyFilter(item, queryText, itemText) {
				if (queryText.length > 0)
					this.$store.dispatch("GetBuyAbstractForPerson", {
						text: queryText,
						personId: this.otherWorkModel.personId,
						prebuyInvoiceId: this.otherWorkModel.prebuyInvoiceId,
						contractId: this.otherWorkModel.contractId,
					});
				return this.$store.getters.GetBuyList;
			},


			onchangeBuy() {
				console.log("")
			},




			onChangeWorkGroup() {
				this.otherWorkModel.mentionUserIdsList = [];
				this.$store.dispatch("GetLocalUserListListFromServer", {
					workGroupId: this.otherWorkModel.workGroupId
				});
				this.$store.dispatch("GetLocalUserListForMention", {
					workGroupId: this.otherWorkModel.workGroupId
				});
			},

			UserPresenceArrivalFilter(item, queryText, itemText) {
				this.$store.dispatch("GetArrivalListForRef", {
					text: queryText,
					data: this.otherWorkModel.workDate
				});
				return this.$store.getters.GetArrivalListForRef;
			},
			onchangeUserPresenceArrival(isReload = false) {
				if (isReload) {
					this.otherWorkModel.arrivalUserPresenceId = null;
					this.$store.dispatch("GetArrivalListForRef", {
						data: this.otherWorkModel.workDate
					});
				}
				this.otherWorkModel.departureUserPresenceId = null;
				this.ShowDepartureUserPresenceInfo = false;

				this.$store.dispatch("GetDepartureListForRef", {
					data: this.otherWorkModel.workDate,
					removedId: this.otherWorkModel.arrivalUserPresenceId,
				});
				this.ShowArrivalUserPresenceInfo = false;
				if (this.otherWorkModel.arrivalUserPresenceId != null) {
					this.ShowArrivalUserPresenceInfo = true;
					this.$http.get("UserPresence/GetUserPresenceItem?id=" + this.otherWorkModel.arrivalUserPresenceId)
						.then(data => {
							this.arrivalUserPresenceAddress = data.data.address;
							var m = data.data.mapLocation.split(',');
							this.mapLocationObjectArrival = latLng(m[0], m[1]);
							this.mapLocationArrival = data.data.mapLocation;
						});
				}
			},
			onClearedUserPresenceArrival() {
				this.otherWorkModel.departureUserPresenceId = null;
			},

			UserPresenceDepartureFilter(item, queryText, itemText) {
				this.$store.dispatch("GetDepartureListForRef", {
					text: queryText,
					data: this.otherWorkModel.workDate,
					removedId: this.otherWorkModel.arrivalUserPresenceId,
				});
				return this.$store.getters.GetDepartureListForRef;
			},
			onchangeUserPresenceDeparture(isReload = false) {
				if (isReload) {
					this.otherWorkModel.departureUserPresenceId = null;
					this.$store.dispatch("GetDepartureListForRef", {
						data: this.otherWorkModel.workDate,
						removedId: this.otherWorkModel.arrivalUserPresenceId,
					});
				}
				this.ShowDepartureUserPresenceInfo = false;
				if (this.otherWorkModel.departureUserPresenceId != null) {
					this.ShowDepartureUserPresenceInfo = true;
					this.$http.get("UserPresence/GetUserPresenceItem?id=" + this.otherWorkModel.departureUserPresenceId)
						.then(data => {
							this.departureUserPresenceAddress = data.data.address;
							var m = data.data.mapLocation.split(',');
							this.mapLocationObjectDeparture = latLng(m[0], m[1]);
							this.mapLocationDeparture = data.data.mapLocation;
						});
				}
			},
			showMapLocation(isDeparture) {
				// If it's an iPhone..
				if (isDeparture) {
					if ((navigator.platform.indexOf("iPhone") != -1)
						|| (navigator.platform.indexOf("iPod") != -1)
						|| (navigator.platform.indexOf("iPad") != -1))
						window.open("maps://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=" + this.mapLocationDeparture);
					else
						window.open("https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=" + this.mapLocationDeparture);
				} else {
					if ((navigator.platform.indexOf("iPhone") != -1)
						|| (navigator.platform.indexOf("iPod") != -1)
						|| (navigator.platform.indexOf("iPad") != -1))
						window.open("maps://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=" + this.mapLocationArrival);
					else
						window.open("https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=" + this.mapLocationArrival);
				}
			},
			startR() {
				try {
					this.sr.start();
					this.showType = true;
					this.btnRecord = "btn btn-success speechToTextBtn-i-L";
				} catch (error) {
					console.error(error);
					this.showType = true;
					// Expected output: ReferenceError: nonExistentFunction is not defined
					// (Note: the exact output may be browser-dependent)
				}

			},
			stopR() {
				try {
					this.sr.stop();
					this.showType = false;
					this.btnRecord = "btn btn-danger speechToTextBtn-i";
				} catch (error) {
					console.error(error);
					this.showType = false;
					// Expected output: ReferenceError: nonExistentFunction is not defined
					// (Note: the exact output may be browser-dependent)
				}
			},
			CreateOtherWork() {

				this.v$.$touch(); //it will validate all fields
				if (!this.v$.$invalid) { //invalid, becomes true when a validations return false
					this.modified = false;
					if (this.otherWorkModel.quantity == "" || this.otherWorkModel.quantity == null) {
						this.otherWorkModel.quantity = 0;
					}
					this.$store.dispatch("CreateOtherWork", this.otherWorkModel);
					this.modified = false;
				}

			},
			onShowTypeModal(show) {
				if (show) {
					document.getElementsByClassName('menu-hider')[0].click();
				}
				this.showTypeModal = show;
			},
			onChangeType(p) {
				if (this.otherWorkModel.subject == null || this.otherWorkModel.subject == "") {
					this.otherWorkModel.subject = p.title;
					var element = document.getElementById("Subject")
					var event = new Event('change');
					element.dispatchEvent(event);
				}
			},
			getOtherWorkNo() {
				this.$http.get("OtherWork/GetOtherWorkNo")
					.then(data => {
						this.otherWorkModel.workNo = data.data;
					});

			},
			getServerDateTime() {
				this.$http.get("Task/GetServerDateTime")
					.then(data => {
						this.otherWorkModel.workDate = data.data.split("_")[0];
						this.$store.dispatch("GetArrivalListForRef", {
							data: this.otherWorkModel.workDate
						});

					});

			},
			fixTime() {
				var val = this.otherWorkModel.workUsedTime;
				if (val.length == 1) {
					val = '0' + val + ':00';
				}
				else if (val.length == 2) {
					val = val + ':00';
				}
				else if (val.length == 3) {
					val = val + '00';
				}
				else if (val.length == 4) {
					val = val + '0';
				}
				this.otherWorkModel.workUsedTime = val;
			},
			openWorkType() {
				this.modified = false;
				this.$router.push({ name: 'CreateOtherWorkType' });
				this.modified = true;
			},
			onSearchOtherWorkType(search, loading) {

				loading(true);
				this.otherWorkSearchText = search;
				this.searchOtherWorkType(search);
				loading(false);

			},
			searchOtherWorkType() {
				this.$store.dispatch("GetOtherWorkTypeListFromServer", {
					searchKey: this.otherWorkSearchText
				});
			},
			SetAttList(e) {
				console.log(e);
				this.otherWorkModel.attList = e;
			},
			AttInProgress(e) {
				this.attInProgress = e;
			},
			onTabClick(title) {
				console.log(title);
			},
			pauseVid(id) {
				console.log(id);
				if (id != null) {
					console.log("pause");
					var vid = document.getElementById(id);
					vid.pause();
				}
			},
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
			toggleClasslessDetails() {
				var element = document.getElementById("moreLessDetails");
				element.classList.toggle("lessDetails");
			},
		},
		mounted() {
			try {

				this.sr = new Recognition()
				this.sr.continuous = true
				this.sr.interimResults = true
				this.sr.lang = 'fa-IR';
				var rest = "";
				this.sr.onstart = () => {
					this.showType = true;
					this.btnRecord = "btn btn-success speechToTextBtn-i-L";
				}
				this.sr.onresult = (evt) => {
					rest = evt.results[evt.results.length - 1][0].transcript;
				}
				this.sr.onend = () => {
					if (this.otherWorkModel.description == null || this.otherWorkModel.description == "null")
						this.otherWorkModel.description = "";
					this.otherWorkModel.description = this.otherWorkModel.description + " " + rest
					this.btnRecord = "btn btn-danger speechToTextBtn-i";
					this.showType = false;
				}
			} catch (error) {
				console.error(error);
				// Expected output: ReferenceError: nonExistentFunction is not defined
				// (Note: the exact output may be browser-dependent)
			}
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
		},
		validations: {
			otherWorkModel: {
				workNo: {
					required,
				},
				workDate: {
					required
				},
				subject: {
					required
				},
				otherWorkTypeId: {
					required
				},
				workUsedTimeMinute: {
					between: between(0, 59)
				},
				workUsedTimeHour: {
					between: between(0, 1000)
				},

			}


		},
		directives: { maska },
		beforeRouteLeave(to, from, next) {
			if (this.modified == true) {
				VueSimpleAlert.fire({
					title: 'با بستن این صفحه تغییرات شما ذخیره نخواهد شد. آیا ادامه می دهید؟',
					showCancelButton: true,
					confirmButtonText: 'تأیید',
					cancelButtonText: `انصراف`,
				}).then((result) => {
					console.log(this.modified);

					if (result.value == true) {
						next();
					} else {
						next(false);
					}
				})
			}
			else {
				next();
			}
		}

	};
</script>
